// extracted by mini-css-extract-plugin
export default {"wrapper":"Page_wrapper__Wr2Ov","head":"Page_head__DLgok"};